import jwtDecode from "jwt-decode";
import { Auth } from "aws-amplify";

/**
 * helper method to validate  user token
 *
 * @param {*} token
 * @returns {boolean}
 */
export const validateToken = (token: any): boolean => {
  if (!token) {
    return false;
  }
  try {
    const decodedJwt: any = jwtDecode(token);
    return decodedJwt.exp >= Date.now() / 1000;
  } catch (e) {
    return false;
  }
};

/**
 * Check the session token payload to validate user is in the Paid group
 */
export const isPaidUser = (): Promise<boolean> =>
  Auth.currentSession().then((session) => {
    return session.getAccessToken().payload["cognito:groups"]?.includes("Paid");
  });
